import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import { formatMoney, formatDate, refundSummary, invoicePill } from "../dashboardHelpers";
import { INVOICE_PILL_COLOR, INVOICE_PILL_LABEL } from "../dashboardConstants";
import RowShell from "./RowShell";

function InvoiceRow({ invoice, currency, onPayNow, payLoadingId, onView }) {
  const isUnpaid = invoice.status === "UNPAID";
  // A refund is stored as a PAID invoice of type REFUND; it reads as a refund, with what
  // came back, not as a payment of AED 0.00.
  const refund = invoice.refund;
  // A write-off is stored the same way but gave nothing back — the client never paid.
  const isWriteoff = refund?.destination === "WRITEOFF";
  const cur = invoice.currency || currency;
  const pill = invoicePill(invoice);
  // The invoice a write-off cancelled keeps its full total; without a word beside it the
  // amount reads as something still owed.
  const amountLabel = invoice.status === "WRITEOFF" ? `${formatMoney(invoice.total, cur)} — not charged` : formatMoney(invoice.total, cur);
  return (
    <RowShell onClick={onView ? () => onView(invoice) : undefined}>
      <Box flex={1} minWidth={0}>
        <Typography variant="subtitle2" noWrap>
          #{invoice.invoiceNumber || invoice._id.slice(-6)}
          {refund && invoice.refundOfInvoiceNumber && (
            <Typography component="span" variant="caption" color="textSecondary" sx={{ ml: 1 }}>
              {isWriteoff ? "Write-off" : "Refund"} for #{invoice.refundOfInvoiceNumber}
            </Typography>
          )}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {formatDate(invoice.date)} — {refund ? refundSummary(refund, cur) : amountLabel}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1.5} onClick={(e) => e.stopPropagation()}>
        <Chip
          size="small"
          label={INVOICE_PILL_LABEL[pill] || pill}
          color={INVOICE_PILL_COLOR[pill] || "default"}
          variant="outlined"
          sx={{ height: "1.375rem", fontSize: "0.7rem", fontWeight: 500, letterSpacing: 0.3 }}
        />
        {isUnpaid && (
          <Button
            size="small"
            variant="contained"
            disabled={payLoadingId === invoice._id}
            onClick={() => onPayNow(invoice._id, invoice._id)}
            sx={{ height: "1.75rem", px: 1.5, textTransform: "none", color: "common.white", boxShadow: "none" }}
          >
            {payLoadingId === invoice._id ? <CircularProgress size={16} /> : "Pay Now"}
          </Button>
        )}
      </Box>
    </RowShell>
  );
}

export default InvoiceRow;
